import type { Transaction } from '@/lib/types';

type TransactionAmountInput = Pick<Transaction, 'type' | 'amount' | 'discountAmount'>;

export interface TransactionAmountBreakdown {
  gross: number;
  discount: number;
  net: number;
  signedNet: number;
}

export function getTransactionAmountBreakdown(txn: TransactionAmountInput): TransactionAmountBreakdown {
  const amount = Number.isFinite(txn.amount) ? txn.amount : 0;
  const gross = Math.abs(amount);
  const discount = Math.max(0, txn.discountAmount ?? 0);
  const net = Math.max(0, gross - discount);
  const signedNet = txn.type === 'expense' ? -net : net;

  return {
    gross,
    discount,
    net,
    signedNet,
  };
}

export function getGroupSignedNetTotal(transactions: TransactionAmountInput[]): number {
  return transactions.reduce((total, txn) => {
    return total + getTransactionAmountBreakdown(txn).signedNet;
  }, 0);
}

export function toStableGroupKey(groupLabel: string): string {
  const normalized = groupLabel
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return normalized || 'group';
}
